import { z } from 'zod';
import { isValidIsoDate } from '../dates.js';

/** ISO calendar date, YYYY-MM-DD, checked against the real calendar. */
export const IsoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD')
  .refine(isValidIsoDate, { message: 'Impossible calendar date' });

/** Numeric PCG account number with at least three digits. */
export const AccountNumSchema = z
  .string()
  .regex(/^\d{3,}$/, 'Account number must contain at least 3 digits');

/** Monetary/quantity value as a decimal string (never a float). */
export const DecimalStringSchema = z.string().regex(/^-?\d+(\.\d+)?$/, 'Must be a decimal string');
